// src/app/departments/constants/department-import-headers.const.ts
export const DEPARTMENT_IMPORT_HEADERS = ['Name', 'Code', 'ParentDepartmentCode'] as const;

export type DepartmentImportHeader = (typeof DEPARTMENT_IMPORT_HEADERS)[number];